import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthPagesGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      // If a user is currently logged in and another user tries to confirm their account or set a password, log them out first so the new user can complete the flow uninterrupted.
      if (state.url.includes('confirm-account') || state.url.includes('set-password')) {
        this.authService.logout(state.url);
        return true;
      }
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
